var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loaded)?_c('div',{staticClass:"d-flex height-100vh justify-center",style:(_vm.verticalPosition)},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }